import { AvatarGroup, AvatarGroupProps } from "@mui/material";

interface StyleAvatarGroupProps extends AvatarGroupProps {
  size?: "small" | "medium" | "large";
  outlineColor?: string;
}

export const StyleAvatarGroup = (props: StyleAvatarGroupProps) => {
  const {
    size = "medium",
    outlineColor,
    variant = "square",
    sx,
    ...rest
  } = props;

  let avatarSize = 16;
  let fontSize = 10;
  if (size === "medium") {
    avatarSize = 24;
    fontSize = 12;
  } else if (size === "large") {
    avatarSize = 32;
    fontSize = 14;
  }

  const avatarGroupSx = [
    {
      "&& .MuiAvatar-root": {
        borderColor: outlineColor,
        width: avatarSize,
        height: avatarSize,
        fontSize,
        flexShrink: 0,
        borderRadius: variant === "rounded" ? "50%" : 1,
      },
    },
    ...(Array.isArray(sx) ? sx : [sx]),
  ];

  const AvatarGroupAny = AvatarGroup as React.ComponentType<any>;

  return (
    <AvatarGroupAny
      variant={variant}
      spacing={6}
      max={10}
      sx={avatarGroupSx}
      {...rest}
    />
  );
};
